import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHelper } from '@ck-core/ck-auth';


@Injectable({ providedIn: 'root' })
export class FeedbackService {
    constructor(private http: HttpHelper) {}

    public SaveFeedback(payload: any) {
        return this.http.post(`${environment.commandUrl}feedbacks`, payload);
    }
}
